export default __webpack_public_path__ + "static/WilliamPotter-7dbf3dec2f3d07acd7a2953ade14b273.jpg";